import React from 'react';
import { FaFileAlt } from 'react-icons/fa';
import { Fade } from 'react-reveal';
import { Button, Col, Container, Row } from 'reactstrap';
import code from '../assets/lottie/office.json';
import '../assets/scss/argon-design-system-react.scss';
import DisplayLottie from '../components/DisplayLottie';
import SocialLinks from '../components/SocialLinks';
import { greetings } from '../portfolio';

function Greeting() {
  return (
    <Fade top duration={1000} distance="40px">
      <div className="section section-lg section-shaped pb-250  h-50">
        <div className="shape shape-style-1 bg-gradient-primary">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <Container className="py-lg-md d-flex">
          <div className="col px-0">
            <Row>
              <Col lg="6">
                <h1 className="display-3 text-white">{`${greetings.title} `}</h1>
                <p className="lead text-white">{greetings.description}</p>
                <SocialLinks />
                <div className="btn-wrapper my-4">
                  <Button
                    className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                    color="default"
                    target="_blank"
                    href={greetings.resumeLink}
                  >
                    <span className="btn-inner--icon mr-1">
                      <FaFileAlt />
                    </span>
                    <span className="btn-inner--text">See My Resume</span>
                  </Button>
                </div>
                <div className="btn-wrapper my-4">
                  <Button
                    className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                    color="default"
                    target="_blank"
                    href={greetings.resumeDownload}
                  >
                    <span className="btn-inner--icon mr-1">
                      <FaFileAlt />
                    </span>
                    <span className="btn-inner--text">Download Resume</span>
                  </Button>
                </div>
              </Col>
              <Col lg="6">
                <DisplayLottie animationData={code} />
              </Col>
            </Row>
          </div>
        </Container>
        <div className="separator separator-bottom separator-skew">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon className="fill-white" points="2560 0 2560 100 0 100" />
          </svg>
        </div>
      </div>
    </Fade>
  );
}

export default Greeting;
